const ComponentsLookup = {
  "default-footer": "DefaultFooterD2c915b2169842c9944e674d6a4ff566"
}

export default ComponentsLookup;